
import React, { useEffect } from 'react';
import { Card, CardHeader, CardTitle, CardContent } from '@/components/ui/card';
import { FormField, FormItem, FormLabel, FormControl, FormMessage } from '@/components/ui/form';
import { Input } from '@/components/ui/input';
import { UseFormReturn } from 'react-hook-form';
import { useLanguage } from '@/hooks/useLanguage';

interface IntegrationSectionProps {
  form: UseFormReturn<any>;
  isLoading: boolean;
}

const IntegrationSection: React.FC<IntegrationSectionProps> = ({
  form,
  isLoading
}) => {
  const { translate } = useLanguage();
  
  // Debug the prom_avarn value when it changes
  useEffect(() => {
    const subscription = form.watch();
    console.log("IntegrationSection form values:", subscription);
  }, [form.watch('prom_avarn'), form.watch('alarm_com_id'), form.watch('invoice_reference')]);
  
  return (
    <Card className="bg-white">
      <CardHeader>
        <CardTitle>{translate('subscriptions.integrationInfo')}</CardTitle>
      </CardHeader>
      <CardContent>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <FormField
            control={form.control}
            name="alarm_com_id"
            render={({ field }) => (
              <FormItem>
                <FormLabel>{translate('subscriptions.alarmComId')}</FormLabel>
                <FormControl>
                  <Input
                    id="alarm_com_id"
                    disabled={isLoading}
                    placeholder={translate('subscriptions.alarmComId')}
                    {...field}
                    value={typeof field.value === 'string' ? field.value : ''}
                  />
                </FormControl>
                <FormMessage />
              </FormItem>
            )}
          />
          
          <FormField
            control={form.control}
            name="prom_avarn"
            render={({ field }) => (
              <FormItem>
                <FormLabel>{translate('subscriptions.promAvarn')}</FormLabel>
                <FormControl>
                  <Input
                    id="prom_avarn"
                    disabled={isLoading}
                    placeholder={translate('subscriptions.promAvarn')}
                    {...field}
                    value={typeof field.value === 'string' ? field.value : ''}
                    onChange={(e) => {
                      console.log("PROM Avarn field changed to:", e.target.value);
                      field.onChange(e.target.value);
                    }}
                  />
                </FormControl>
                <FormMessage />
              </FormItem>
            )}
          />
          
          <FormField
            control={form.control}
            name="invoice_reference"
            render={({ field }) => (
              <FormItem>
                <FormLabel>{translate('subscriptions.invoiceReference')}</FormLabel>
                <FormControl>
                  <Input
                    id="invoice_reference"
                    disabled={isLoading}
                    placeholder={translate('subscriptions.invoiceReference')}
                    {...field}
                    value={typeof field.value === 'string' ? field.value : ''}
                  />
                </FormControl>
                <FormMessage />
              </FormItem>
            )}
          />
        </div>
      </CardContent>
    </Card>
  );
};

export default IntegrationSection;
